import { Pipe, PipeTransform } from '@angular/core';
import { CardRequestType } from '@lib/enums';
import { Optional } from '@lib/interfaces';

@Pipe({
    standalone: true,
    name: 'cardRequestType',
})
export class CardRequestTypePipe implements PipeTransform {
    public transform(value: Optional<CardRequestType>): string {
        switch (value) {
            case CardRequestType.CLASSIC:
                return 'Classic';
            case CardRequestType.GOLD:
                return 'Gold';
            case CardRequestType.PLATINUM:
                return 'Platinum';
            default:
                return '';
        }
    }
}
